import React from "react";
import { motion } from "framer-motion";
import { Clock } from "lucide-react";

const MatchCard = ({
  match,
  countdown,
  formatMatchDate,
  selectedButton,
  onBetClick,
}) => {
  return (
    <motion.div
      className="bg-gray-800 rounded-lg p-3 shadow-md"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
    >
      <div className="flex justify-between items-center mb-2">
        {countdown?.showCountdown ? (
          <span className="text-red-400 text-xs flex items-center font-medium">
            <Clock className="w-3 h-3 mr-1" />
            Inicia en {countdown.minutes}:{countdown.seconds}
          </span>
        ) : (
          <span className="text-gray-400 text-xs flex items-center">
            <Clock className="w-3 h-3 mr-1" />
            {formatMatchDate(match.date, match.hours)}
          </span>
        )}
      </div>
      <div className="flex justify-between items-center">
        <div className="flex items-center">
          {match.homeTeam.logo ? (
            <img
              src={match.homeTeam.logo}
              alt={match.homeTeam.name}
              className="w-6 h-6 rounded-full mr-2 object-cover"
            />
          ) : (
            <span className="bg-gray-700 text-white w-6 h-6 rounded-full flex items-center justify-center text-xs mr-2">
              {match.homeTeam.name.charAt(0)}
            </span>
          )}
          <span className="text-white text-sm">{match.homeTeam.name}</span>
        </div>
        <span className="text-white font-medium mx-2">vs</span>
        <div className="flex items-center">
          <span className="text-white text-sm">{match.awayTeam.name}</span>
          {match.awayTeam.logo ? (
            <img
              src={match.awayTeam.logo}
              alt={match.awayTeam.name}
              className="w-6 h-6 rounded-full ml-2 object-cover"
            />
          ) : (
            <span className="bg-gray-700 text-white w-6 h-6 rounded-full flex items-center justify-center text-xs ml-2">
              {match.awayTeam.name.charAt(0)}
            </span>
          )}
        </div>
      </div>
      <div className="flex justify-between mt-3">
        <BetButton
          selected={selectedButton === match.homeTeam.name}
          label={match.homeTeam.name}
          odd={match.homeTeam.odd.toFixed(2)}
          onClick={() =>
            onBetClick(
              match,
              match.homeTeam.name,
              match.homeTeam.odd.toFixed(2)
            )
          }
          className="mr-1"
        />
        <BetButton
          selected={selectedButton === "Empate"}
          label="Empate"
          odd="3.25"
          onClick={() => onBetClick(match, "Empate", 3.25)}
          className="mx-1"
        />
        <BetButton
          selected={selectedButton === match.awayTeam.name}
          label={match.awayTeam.name}
          odd={match.awayTeam.odd.toFixed(2)}
          onClick={() =>
            onBetClick(
              match,
              match.awayTeam.name,
              match.awayTeam.odd.toFixed(2)
            )
          }
          className="ml-1"
        />
      </div>
    </motion.div>
  );
};

// BetButton component for bet options
const BetButton = ({ selected, label, odd, onClick, className }) => {
  return (
    <motion.button
      className={`${
        selected
          ? "bg-yellow-500 text-black"
          : "bg-gray-700 hover:bg-gray-600 text-white"
      } text-xs py-1 px-3 rounded flex-1 ${className}`}
      whileTap={{ scale: 0.95 }}
      onClick={onClick}
    >
      <div className="flex justify-between">
        <span>{label}</span>
        <span className="font-medium">{odd}</span>
      </div>
    </motion.button>
  );
};

export default MatchCard;
